import { MDBAlert } from 'mdb-react-ui-kit'
import React from 'react'

function TopMessage({ successMessage }) {
  return (
    <>
      <MDBAlert
        open
        className="alert-center"
        color="success"
        autohide
        position="bottom-right"
        delay={10000}
      >
        <i className="fas fa-check-circle me-3"></i>
        <span className="alert-msg">{successMessage}</span>
      </MDBAlert>

    </>
  )
}

export default TopMessage
